import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";
import { AuctionActions, IAuctionState } from "./Auction";
import {
  fetchAuctionDataOnlyEpic,
  fetchAuctionDataOnlyWithDateEpic,
  fetchFilterAndAuctionDataEpic,
} from "./Auction/Epic";
import {
  associateBookWithDocIdEpic,
  fetchBookAndDocIdEpic,
  fetchBooksEpic,
} from "./Book/Epic";
import {
  auctionReducer,
  initialState as initialStateAuction,
} from "./Auction/Reducer";
import { IBidPanelState, BidPanelActions } from "./Bid";
import { draftBidEpic, submitBidEpic } from "./Bid/Epic";
import { bidPanelReducer, initialBidPanelState } from "./Bid/Reducer";
import { BidHistoryActions, IBidHistoryState } from "./BidHistory";
import { retrieveHistoryEpic } from "./BidHistory/Epic";
import {
  bidHistoryReducer,
  initialBidHistoryState,
} from "./BidHistory/Reducer";
import { bookReducer, initialState as initialStateBook } from "./Book/Reducer";
import { BookActions, IBookState } from "./Book";
import { AuthActions, IAuthState } from "./Auth";
import { authReducer, initialState as initialStateAuth } from "./Auth/Reducer";
import { authenticateUserEpic } from "./Auth/Epic";

import { ExchangeConfigActions, IExchangeConfigState } from "./ExchangeConfig";
import { exchangeConfigReducer, initialState as initialExchangeConfigState } from "./ExchangeConfig/Reducer"
import { fetchExchangeConfigEpic, postExchangeConfigUpdaactionEpic } from "./ExchangeConfig/Epic"
import { EtrmConfigActions, IEtrmConfigState } from "./EtrmConfig";
import { etrmConfigReducer, initialState as initialEtrmConfigState } from "./EtrmConfig/Reducer";
import { fetchEtrmConfigEpic, postEtrmConfigEpic } from "./EtrmConfig/Epic";
import { IResultState, ResultActions } from "./Result";
import { initialResultState, resultReducer } from "./Result/Reducer";
import { ProfileActions, IProfileState } from "./Profile";
import { profileReducer, initialState as initialProfileState } from "./Profile/Reducer";
import { fetchProfileEpic } from "./Profile/Epic";
import { IResultsState, ResultsActions } from "./Results";
import { initialResultsState, resultsReducer } from "./Results/Reducer";
import { fetchAuctionResultsEpic } from "./Results/Epic";

import { AuditActions, IAuditState } from "./Audit";
import { auditReducer, initialState as initialStateAudit } from "./Audit/Reducer";
import { postAuditEpic } from "./Audit/Epic";
import { AuctionCalendarActions, IAuctionCalendarState } from "./AuctionCalendar";
import { fetchFilterAndAuctionCalendarEpic } from "./AuctionCalendar/Epic";
import { initialState as initialStateAuctionCalendar, auctionCalendarReducer  } from "./AuctionCalendar/Reducer";
import { fetchSourceAuctionsEpic, submitCapacityReturnEpic } from "./Returns/Epic";
import { initialState as initialReturnsState, ReturnsReducer } from "./Returns/Reducer";
import { IReturnsState, ReturnsActions } from "./Returns/index";


export interface IApplicationState {
  readonly auction: IAuctionState;
  readonly auctionCalendar: IAuctionCalendarState;
  readonly audit: IAuditState;
  readonly auth: IAuthState;
  readonly bidPanel: IBidPanelState;
  readonly bidHistory: IBidHistoryState;
  readonly book: IBookState;
  readonly exchangeconfig: IExchangeConfigState;
  readonly etrmconfig: IEtrmConfigState;
  readonly result: IResultState;
  readonly results: IResultsState;
  readonly returns: IReturnsState;
  readonly profile: IProfileState;
}

export const initialStateApplication: IApplicationState = {
  auction: initialStateAuction,
  auctionCalendar: initialStateAuctionCalendar,
  bidPanel: initialBidPanelState,
  bidHistory: initialBidHistoryState,
  book: initialStateBook,
  auth: initialStateAuth,
  exchangeconfig: initialExchangeConfigState,
  etrmconfig: initialEtrmConfigState,
  result: initialResultState,
  results: initialResultsState,
  returns: initialReturnsState,
  profile: initialProfileState,
  audit: initialStateAudit 
};

export const RootReducer = combineReducers({
  auction: auctionReducer,
  auctionCalendar: auctionCalendarReducer,
  audit: auditReducer,
  bidPanel: bidPanelReducer,
  bidHistory: bidHistoryReducer,
  book: bookReducer,
  auth: authReducer,
  exchangeconfig: exchangeConfigReducer,
  etrmconfig: etrmConfigReducer,
  profile: profileReducer,
  result: resultReducer,
  results: resultsReducer,
  returns: ReturnsReducer,
});

export interface IAuctionFilters {
  corridorKeys?: string[];
  corridors?: IFilterItem[];
  startDateUtc?: Date;
  interconnectors?: IFilterItem[];
  bidStatus?: IFilterItem[];
  products?: IFilterItem[];
  exchanges?: IFilterItem[];
  isShow?: boolean;
}

export interface IFilterItem {
  value: string;
  color?: string;
  isSelected: boolean;
}

export interface ICorridorStatusRequest {
  corridorCode: string;
}

export interface IAuctionCalendarUpdateRequest {
  isCalendarUpdated: boolean;
}

export interface IAllocationResultUpdate {
  auctionId: string;
  quantity: number;
  price: number;
  status: string;
  zkey: string;
  errorMessage: string[];
}

export const RootEpic = combineEpics<any, any, any | IApplicationState, any>(
  fetchFilterAndAuctionDataEpic,
  fetchAuctionDataOnlyEpic,
  fetchAuctionResultsEpic,
  fetchSourceAuctionsEpic,
  submitCapacityReturnEpic,
  submitBidEpic,
  draftBidEpic,
  retrieveHistoryEpic,
  fetchBooksEpic,
  authenticateUserEpic,
  fetchBookAndDocIdEpic,
  associateBookWithDocIdEpic,
  fetchAuctionDataOnlyWithDateEpic,
  fetchExchangeConfigEpic,
  postExchangeConfigUpdaactionEpic,
  fetchEtrmConfigEpic,
  postEtrmConfigEpic,
  fetchProfileEpic,
  postAuditEpic,
  fetchFilterAndAuctionCalendarEpic
);

export {
  FetchFiltersAndAuctionDataAction,
  FetchedFiltersAndAuctionDataSuccessAction,
  UpateAuctionCorridorFilterValueAction,
  FetchAuctionDataOnlyAction,
  FetchedAuctionDataOnlySuccessAction,
  UpateAuctionInterconnectorFilterValueAction,
  UpateAuctionIsShowFilterValueAction,
  UpateAuctionBidStatusFilterValueAction,
  UpdateAuctionExchangeFilterValueAction,
  FetchAuctionDataOnlyWithDateAction,
} from "./Auction/ActionCreator";

export {
  FetchedFiltersAndAuctionCalendarSuccessAction,
  FetchFiltersAndAuctionCalendarAction,
  FetchedFiltersAndAuctionCalendarFailedAction,
  UpateAuctionCalendarCorridorFilterValueAction,
  UpateAuctionCalendarProductFilterValueAction,
  UpateAuctionCalendarIsShowFilterValueAction,
  UpateAuctionCalendarInterconnectorFilterValueAction,
  UpdateAuctionCalendarExchangeFilterValueAction,
} from "./AuctionCalendar/ActionCreator";

export {
  ShowBidPanelAction,
  HideBidPanelAction,
  SubmitBidAction,
  SubmitBidFailedAction,
} from "./Bid/ActionCreator";

export {
  FetchSubmissionHistory,
  ClearSubmissionHistory,
  FetchedSubmissionHistorySuccessfully,
} from "./BidHistory/ActionCreator";

export {
  FetchBookAction,
  FetchBookSuccessAction,
  FetchBookFailedAction,
  FetchBookWithDocIdByDocIdAction,
  FetchBookWithDocIdByDocIdSuccessAction,
  FetchBookWithDocIdByDocIdFailureAction,
  AssociateBookWithDocIdAction,
  AssociateBookWithDocIdSuccessAction,
  AssociateBookWithDocIdFailureAction,
} from "./Book/ActionCreator";

export {
  AuthenticateUserAction,
  AuthenticateUserSuccessAction,
  AuthenticateUserFailureAction,
} from "./Auth/ActionCreator";

export {
  FetchExchangeConfigAction,
  FetchExchangeConfigSuccessAction,
  FetchExchangeConfigFailedAction,
  PostExchangeConfigAction,
  PostExchangeConfigFailedAction,
  PostExchangeConfigSuccessAction
} from "./ExchangeConfig/ActionCreator";

export {
  FetchEtrmConfigAction,
  FetchEtrmConfigSuccessAction,
  FetchEtrmConfigFailedAction,
  PostEtrmConfigAction,
  PostEtrmConfigFailedAction,
  PostEtrmConfigSuccessAction
} from "./EtrmConfig/ActionCreator";

export {
  ShowResultPanelAction,
  HideResultPanelAction
} from "./Result/ActionCreator";

export {
  ShowResultsPanelAction,
  HideResultsPanelAction,
  FetchAuctionResultsAction,
  FetchAuctionResultsSuccessAction,
  FetchAuctionResultsFailedAction
} from "./Results/ActionCreator";


export {
  ShowReturnsPanelAction,
  HideReturnsPanelAction,
  FetchCapacityReturnsAction,
  FetchCapacityReturnsSuccessAction,
  FetchCapacityReturnsFailedAction
} from "./Returns/ActionCreator";

export {
  FetchProfileAction,
  FetchProfileSuccessAction,
  FetchProfileFailedAction,
} from "./Profile/ActionCreator";

export type RootActions =
  | AuctionActions
  | AuctionCalendarActions
  | BidPanelActions
  | BidHistoryActions
  | BookActions
  | AuthActions
  | ExchangeConfigActions
  | EtrmConfigActions
  | ReturnsActions
  | ResultActions
  | ResultsActions
  | ProfileActions
  | AuditActions;

// Typed dispatch hook for react-redux v9 compatibility.
// react-redux v9 changed useDispatch() to return Dispatch<UnknownAction> by default,
// while redux v5 changed Action from an interface to a type alias (preventing augmentation).
// This hook casts to Dispatch<RootActions> so components can dispatch typed actions.
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';
export const useAppDispatch = () => useDispatch<Dispatch<RootActions>>();
